module.exports = __webpack_public_path__ + "img/logo_IFA.52e229dd.png";